module.exports = "https://static.wmbcdn.com/uniweb/images/fca65a600a4f039aca91b9a6f7345f14.svg";